import { useMemo } from 'react';

export default function useDiscountPermissions({
    isAdmin,
    isAllCompanies,
}) {
    return useMemo(() => {
        const isGlobalAdmin =
            isAdmin && isAllCompanies;

        const isScopedCompanyMode =
            !isGlobalAdmin;

        const hideRmbDiscount =
            !isAdmin;

        return {
            isGlobalAdmin,
            isScopedCompanyMode,
            hideRmbDiscount,
        };
    }, [
        isAdmin,
        isAllCompanies,
    ]);
}